import { Link } from "react-router-dom"
import "./footer.css"

export default function Footer() {
    return (
        <footer className="footere">
            <div className="containeri">
                <div className="footer-grid">
                    <div className="footer-column">
                        <span className="span_sim">Sobre Nós</span>
                        <p className="pe">Ajudamos pessoas a conquistarem sua independência financeira através de educação e planejamento.</p>
                    </div>

                    <div className="footer-column">
                        <span className="span_sim">Contato</span>
                        <div className="footer-contact">
                            <p className="pe">📧 felipedequadrosgomes18@gmail.com</p>
                            <p>📍 São Paulo, SP</p>
                        </div>
                    </div>
                    <div className="div_button_footer">
                    <Link  className="footer_a" to="/politicadeprivacidade">
                        Politica de Privacidade
                    </Link>
                    <Link className="footer_a" to="/sobrenos">
                        Sobre Nos
                    </Link>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p className="pe">&copy; 2024 Finanças Pessoais. Todos os direitos reservados.</p>
                </div>

            </div>
        </footer>
    )
}